
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'Go Template - URL Shortener | Aaron Cunliffe',
    description: 'A Go project template demonstrating REST API structure, Postgres, Docker, sqlc, testing patterns, and CI using a URL shortener example.'
  },
  data () {
    return {
      lightboxSrc: null as string | null,
      lightboxOpen: false
    }
  },
  methods: {
    openLightbox (src: string): void {
      this.lightboxSrc = src
      this.lightboxOpen = true
    },
    closeLightbox (): void {
      this.lightboxOpen = false
    }
  },
  beforeCreate (): void {
    const plugin = document.createElement('script')
    plugin.setAttribute(
      'src',
      'https://cdn.jsdelivr.net/gh/google/code-prettify@master/loader/run_prettify.js?lang=go&skin=desert'
    )
    plugin.async = true
    document.head.appendChild(plugin)
  }
})
